<!-- Search Trigger Input -->
<div
    class="w-full flex items-center bg-white/50 dark:bg-white/5 px-3 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-primary rounded-md">
    <div class="flex flex-row w-full gap-x-2 items-center text-gray-700">
        <div class="shrink-0 text-base text-gray-400 select-none sm:text-sm/6">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
            </svg>
        </div>
        @if (magicSearchService.selectedPointer()) {
        @let pointer = magicSearchService.selectedPointer();
        @let isBlue = pointer.class.includes('blue');
        @let isPurple = pointer.class.includes('purple');
        <span class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium shrink-0 border"
            [class]="isBlue ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-700 text-blue-700 dark:text-blue-300' : 
                     isPurple ? 'bg-primary/10 dark:bg-primary/25 border-primary/25 dark:border-primary/35 text-accent' : 
                     'bg-pink-50 dark:bg-pink-900/30 border-pink-200 dark:border-pink-700 text-pink-700 dark:text-pink-300'">
            {{ pointer.label }}
        </span>
        }
        <input #triggerInput type="text" placeholder="Search for anything..." (focus)="openSearch()"
            (click)="openSearch()" [value]="magicSearchService.searchQuery()"
            class="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-2 text-base text-primary placeholder:text-gray-500 focus:outline-none sm:text-sm/6 cursor-pointer"
            readonly />
        <div class="shrink-0 text-base text-gray-400 select-none sm:text-sm/6 flex items-center">
            <span
                class="inline-flex items-center rounded-md dark:bg-white/10 bg-gray-100 px-4 py-1 text-xs font-medium text-secondary gap-x-1.5 flex-nowrap whitespace-nowrap">
                <span class="hidden sm:inline">⌘K</span>
            </span>
        </div>
    </div>
</div>



<!-- Search Overlay -->
@if (isOpen()) {
<div class="fixed inset-0 z-50 flex items-start justify-center pt-12 sm:pt-20" (click)="closeSearch()">
    <!-- Backdrop with blur -->
    <div class="fixed inset-0 bg-black/40 backdrop-blur-sm"></div>

    <!-- Search Modal -->
    <div class="relative w-full max-w-3xl mx-4 bg-white dark:bg-zinc-700 rounded-lg shadow-2xl"
        (click)="$event.stopPropagation()">

        <!-- Main Search Bar -->
        <div class="flex items-center gap-x-2 px-4 py-3 border-b border-gray-200 dark:border-gray-700">
            <!-- Search Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-gray-400 shrink-0">
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
            </svg>

            @if (magicSearchService.selectedPointer()) {
            @let pointer = magicSearchService.selectedPointer();
            @let isBlue = pointer.class.includes('blue');
            @let isPurple = pointer.class.includes('purple');
            <span class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium shrink-0 border"
                [class]="isBlue ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-700 text-blue-700 dark:text-blue-300' : 
                         isPurple ? 'bg-primary/10 dark:bg-primary/25 border-primary/25 dark:border-primary/35 text-accent' : 
                         'bg-pink-50 dark:bg-pink-900/30 border-pink-200 dark:border-pink-700 text-pink-700 dark:text-pink-300'">
                {{ pointer.label }}
            </span>
            }

            <!-- Search Input -->
            <input id="magic-search-input" type="text" [value]="magicSearchService.searchQuery()"
                (input)="onSearchInput($event)" (keydown.enter)="performSearch()" (keydown.backspace)="onBackspace($event)"
                placeholder="Describe desired creator persona..."
                class="flex-1 bg-transparent text-primary placeholder:text-gray-400 placeholder:text-sm focus:outline-none text-base">


            <div class="flex flex-row">
                @if (magicSearchService.selectedPointer().class.includes('blue')) {
                <span
                    class="inline-flex items-center gap-x-1.5 flex-nowrap rounded-md whitespace-nowrap dark:bg-white/20 bg-gray-100 text-xs font-semibold ring-1 ring-inset ring-white/5 px-2 py-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path d="M10 3v11" />
                        <path d="M10 9H7a1 1 0 0 1 0-6h8" />
                        <path d="M14 3v11" />
                        <path d="m18 14 4 4H2" />
                        <path d="m22 18-4 4" />
                    </svg>
                    Type to search
                </span>
                } @else {
                <span
                    class="inline-flex items-center gap-x-1.5 flex-nowrap rounded-md whitespace-nowrap dark:bg-white/20 bg-gray-100 text-xs font-semibold ring-1 ring-inset ring-white/5 px-2 py-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-3">
                        <path d="M20 4v7a4 4 0 0 1-4 4H4" />
                        <path d="m9 10-5 5 5 5" />
                    </svg>
                    To Search
                </span>
                }
                <!-- Close Button -->
                <button type="button" (click)="closeSearch()"
                    class="shrink-0 p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- AI Search Banner -->
        @if (showAIBanner()) {
        <div
            class="rounded-md bg-primary/10 dark:bg-primary/20 p-4 outline outline-primary/20 flex items-center justify-between m-2">
            <div class="flex">
                <div class="shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-accent">
                        <path
                            d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                        <path d="M20 2v4" />
                        <path d="M22 4h-4" />
                        <circle cx="4" cy="20" r="2" />
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-foreground">Try AI Search</h3>
                    <div class="mt-1 text-sm text-secondary">
                        <p>Describe a creator's persona, video, action,
                            or industry keyword. <br />For example: "Female fashion influencer in her 20s from London."
                        </p>
                    </div>
                </div>
            </div>




            @if (magicSearchService.selectedPointer() && magicSearchService.selectedPointer().label !== 'lucky:') {
            <button type="button" (click)="setLuckyPointer()" class="primary-go-button">
                Use AI Search
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4">
                    <path
                        d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                    <path d="M20 2v4" />
                    <path d="M22 4h-4" />
                    <circle cx="4" cy="20" r="2" />
                </svg>
            </button>
            }

        </div>
        }




        <!-- Search Pointers -->
        <div
            class="px-4 py-4 border-b border-gray-200 dark:border-gray-700 rounded-lg m-2 bg-zinc-100 dark:bg-zinc-800">

            @if (!magicSearchService.selectedPointer()) {
            <div class="border-b border-gray-200 pb-3">
                <h3 class="text-sm font-semibold text-accent">Search Pointers</h3>
                <p class="text-xs text-gray-500">Use a <i class="italic">pointer</i> to search in a
                    specific way... Click on a pointer or start by typing the pointer, like "persona:" followed
                    by your search query.</p>
            </div>
            } @else if (magicSearchService.selectedPointer().label === 'lucky:') {
            <div class="w-full border-b border-gray-200 pb-3">
                <h3 class="text-sm font-semibold text-accent">How does the default search work?</h3>
                <p class="text-xs text-gray-500">Describe what you're looking for in regular English. We'll
                    find
                    creators who match your description.</p>
            </div>
            }
            @else {
            <div class="border-b border-gray-200 pb-3">
                <h3 class="text-sm font-semibold text-accent">{{ magicSearchService.selectedPointer().label }}
                </h3>
                <p class="mt-1 text-xs text-gray-500">{{ magicSearchService.selectedPointer().help }}</p>
            </div>
            }

            <div class="w-full flex flex-col space-y-2 divide-y divide-gray-200 dark:divide-gray-700">
                <!-- Blue Pointers -->
                <div>
                    <h2 class="mt-2 text-sm font-medium text-blue-500 dark:text-blue-400">Blue Pointers</h2>
                    <ul role="list" class="mt-1 grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
                        @for (pointer of magicSearchService.blue_pointers; track $index) {
                        @if (!isAdminOnlyBluePointer(pointer)) {
                        <li (click)="selectPointer(pointer)"
                            class="col-span-1 flex items-center justify-between gap-x-6 py-1 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 px-2 rounded">
                            <div class="min-w-0">
                                <div class="flex items-center gap-x-3">
                                    <p class="rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                                        [class]="pointer.class">
                                        {{ pointer.label }}</p>
                                    <p class="text-sm/6 font-semibold text-gray-900 dark:text-gray-200 italic">{{
                                        magicSearchService.searchQuery() && magicSearchService.selectedPointer() &&
                                        magicSearchService.blue_pointers.includes(magicSearchService.selectedPointer())
                                        &&
                                        magicSearchService.selectedPointer().label === pointer.label ?
                                        magicSearchService.searchQuery() : 'Search terms...' }}</p>
                                </div>
                                <div class="mt-0 flex items-center gap-x-2 text-xs/5 text-gray-500 dark:text-gray-400">
                                    <p class="whitespace-nowrap">{{ pointer.description }}</p>
                                </div>
                            </div>
                        </li>
                        }
                        }
                    </ul>
                </div>
                <!-- Blue Pointers END -->

                <!-- Purple Pointers -->
                <div>
                    <h2 class="mt-2 text-sm font-medium text-accent">Purple Pointers</h2>
                    <ul role="list" class="mt-1 grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
                        @for (pointer of magicSearchService.purple_pointers; track $index) {
                        <li (click)="selectPointer(pointer)"
                            class="col-span-1 flex items-center justify-between gap-x-6 py-1 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 px-2 rounded">
                            <div class="min-w-0">
                                <div class="flex items-center gap-x-3">
                                    <p class="rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                                        [class]="pointer.class">
                                        {{ pointer.label }}</p>
                                    <p class="text-sm/6 font-semibold text-gray-900 dark:text-gray-200 italic">
                                        Description...</p>
                                </div>
                                <div class="mt-0 flex items-center gap-x-2 text-xs/5 text-gray-500 dark:text-gray-400">
                                    <p class="whitespace-nowrap">{{ pointer.description }}</p>
                                </div>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
                <!-- Purple Pointers END -->
            </div>
        </div>

        <!-- Recent Searches -->
        <div class="px-4 py-4">
            <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-200 mb-3">Recent searches</h3>
            <div class="space-y-1">
                @for (search of recentSearches(); track $index) {
                <button type="button" (click)="selectRecentSearch(search)"
                    class="w-full flex items-center gap-x-3 px-3 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-left group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 shrink-0">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span class="text-sm text-gray-700 dark:text-gray-300 flex-1">
                        @if (search.includes('in:')) {
                        <span>
                            @if (search.includes('in:devsquad')) {
                            <span
                                class="bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200 px-1 rounded">in:devsquad</span>
                            <span>{{ search.replace('in:devsquad', '') }}</span>
                            } @else if (search.includes('in:@')) {
                            @let parts = search.split(' ');
                            @let inPart = parts[0];
                            @let rest = parts.slice(1).join(' ');
                            <span
                                class="bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200 px-1 rounded">{{
                                inPart }}</span>
                            <span>{{ rest }}</span>
                            } @else {
                            {{ search }}
                            }
                        </span>
                        } @else {
                        {{ search }}
                        }
                    </span>
                </button>
                }
            </div>
        </div>

        <!-- Bottom Navigation Bar -->
        <div
            class="px-4 py-3 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between bg-gray-50 dark:bg-gray-900/50">
            <div class="flex items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m18 15-6-6-6 6" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m6 9 6 6 6-6" />
                </svg>
                <span>Select</span>
            </div>
            <a href="#" class="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300">
                Give feedback
            </a>
        </div>
    </div>
</div>
}